import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { buildEchoConfig } from '@/helpers/echoConfig'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const { data: auth } = useAuth()

  window.Pusher = Pusher

  window.Echo = new Echo(
    buildEchoConfig(
      {
        socketKey: config.public.socketKey,
        socketHost: config.public.socketHost,
        socketPort: config.public.socketPort,
        apiBaseUrl: config.public.apiBaseUrl,
      },
      () => auth?.value?.token,
    ),
  )
})
